import LoadableState from 'components/shared/loadable';
import PageTitle from 'components/shared/PageTitle';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { ArrowLeft } from 'react-feather';
import { requestJourneyContents } from 'actions/journeyViewer';
import { routes } from 'constants/config';
import Loader from './Loader';
import Header from './Header';
import ContentsList from './ContentsList';

const JourneyViewer = props => {
  const { title, loading } = props;

  useEffect(() => {
    props.requestJourneyContents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="JourneyViewer">
      {title && <PageTitle title={title} />}
      {loading && <Loader />}
      <LoadableState loading={loading} opacity={0.5} speed={500}>
        {!props.loading && (
          <>
            <a className="JourneyViewer-actions" href={routes.LEARN}>
              <ArrowLeft className="JourneyViewer-actionIcon" size={16} />
              {t('journeys.viewer.back_to_learning_page')}
            </a>
            <Header />
            <ContentsList />
          </>
        )}
      </LoadableState>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    title: state.title,
    description: state.description,
    loading: state.loading,
  };
};

const mapDispatchToProps = {
  requestJourneyContents,
};

export default connect(mapStateToProps, mapDispatchToProps)(JourneyViewer);
